import React, { useState } from "react";
import close from "../../Pages/MyProfile/assets/close.png";
const RaiseModal = ({ open, setOpen,
  thum,
  profile,
  access,
  participants,
  block,
  status,
  raisedAmountMin,
  raisedAmountMax,
  progress,
  title}) => {
    const handleWrapClick = (e) => {
      e.stopPropagation();
      setOpen(false);
    };

  return (
    <>
      <div
        onClick={handleWrapClick}
        style={{scrollbarWidth: "none",}}
        className="fixed z-20   max-h-screen   overflow-y-scroll  removeScroll top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 flex justify-center items-start "
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className="bg-main-black w-[350px] md:w-[481px] h-max  mt-[60px] md:mt-[100px] rounded-[20px]"
        >
          {/* header */}
          
          <div className="flex justify-between items-center pt-[31px] pl-[10px] md:pl-[36px] pr-[10px] md:pr-[24px] pb-[20px]">
            <h2 className="text-res-normal font-semibold ">Raise Details </h2>
            <button
              onClick={() => {
                setOpen(false);
              }}
              style={{
                boxShadow: "0px 0.909091px 1.81818px rgba(165, 163, 174, 0.3)",
              }}
              className="w-[20px] flex justify-center items-center h-[20px] bg-main-green rounded-[2px] "
            >
              <img src={close} alt="close" />
            </button>
          </div>
          <div className="grow flex justify-center w-full transition-all">
            <div className="bg-main-black w-full rounded-[10px]">
              <div className="pt-[18px] px-[13px]  flex justify-center">
                <div className="relative w-full">
                  <img className="w-full" src={thum} alt="" />
                  <div className="absolute  flex justify-center items-center  bottom-0 rounded-b-[10px] w-full h-[30px] bg-main-green">
                    <h2 className="text-[#0E0E0E] text-[18px] leading-[21px] font-semibold">
                      {title}
                    </h2>
                  </div>
                  <div className="absolute bottom-[8px] left-[17px]">
                    <img src={profile} alt="" />
                  </div>
                </div>
              </div>
              <div className="mt-[17px] pl-[20px] pr-[20px] md:pl-[33px] md:pr-[35px]">
                <ul>
                  <li className="flex justify-between text-res-xs font-semibold mb-[10px]">
                    <h6>Access Tier</h6>
                    <p className="text-bright-green">{access}</p>
                  </li>
                  <li className="flex justify-between text-xs font-semibold mb-[10px]">
                    <h6>Participants</h6>
                    <p className="text-bright-green">participant</p>
                  </li>
                  <li className="flex justify-between text-xs font-semibold mb-[10px]">
                    <h6>Blockchain</h6>
                    <p className="text-bright-green">{block}</p>
                  </li>
                  <li className="flex justify-between text-xs font-semibold mb-[20px]">
                    <h6>Raise Date</h6>
                    <p className="text-bright-green lowercase">{status}</p>
                  </li>
                </ul>
                <div className="">
                  <h4 className="text-res-xs font-semibold mb-[5px]">
                    Raised Amount
                  </h4>
                  <p className="text-res-xs font-semibold mb-[8px] ">
                    <span className="text-bright-green ">{raisedAmountMin} </span> /{" "}
                    {raisedAmountMax}
                  </p>
                  <div className="mb-[19px] h-[9px] relative max-w-100 rounded-full overflow-hidden">
                    <div className="w-full h-full bg-light-black absolute"></div>
                    <div
                      id="bar"
                      className="h-full bg-bright-green relative "
                      style={{ width: progress || "50%" }}
                    ></div>
                  </div>
                </div>
                <div className="pb-[23px]">
                  <h4 className="text-res-xs font-semibold mb-[5px]">
                    Description
                  </h4>
                  <p className="text-res-xs font-semibold mb-[8px] ">
                    <span className="text-bright-green ">{title}</span> {" "}
                    is a well-known project which got partnership with R34P DAO recently.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div onClick={() => setOpen(false)} className="fixed inset-0  z-10"></div>
    </>
  );
};

export default RaiseModal;
